export default "__VITE_ASSET__DBrXV_5j__"